import EditOutlined from '@mui/icons-material/EditOutlined';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function EditOutlinedIcon(props: FixMe) {
  return <EditOutlined {...props} />;
}

export default EditOutlinedIcon;
